import React from 'react';
import { ProductTransaction, ProductTransactionType } from '../../../../../../../types/productTransaction';
import { Grid } from '@mui/material';
import { ProductMasterData } from '../../../../../../../types/product_master_data/productMasterData';
import { Container } from '../../../../../../../types/container';
import ProductTransactionSourceBin from './Common/ProductTransactionSourceBin';
import ProductTransactionSourceContainer from './Common/ProductTransactionSourceContainer';
import ProductTransactionDestinationBin from './Common/ProductTransactionDestinationBin';
import ProductTransactionDestinationContainer from './Common/ProductTransactionDestinationContainer';
import ProductTransactionProcessContainerChildren from './Common/ProductTransactionProcessContainerChildren';
import ProductTransactionSourceLPN from './Common/ProductTransactionSourceLPN';
import ProductTransactionSourceSerial from './Common/ProductTransactionSourceSerial';
import ProductTransactionSourceLot from './Common/ProductTransactionSourceLot';
import ProductTransactionQuantity from './Common/ProductTransactionQuantity';
import ProductTransactionDestinationKit from './Common/ProductTransactionDestinationKit';
import ProductTransactionSourceKit from './Common/ProductTransactionSourceKit';
import ProductTransactionDestinationCustomFields from './Common/ProductTransactionDestinationCustomFields';
import { Divider } from '../../../../../../components/Divider';
import ProductTransactionSourceStockLocation from './Common/ProductTransactionSourceStockLocation';
import ProductTransactionDestinationStockLocation from './Common/ProductTransactionDestinationStockLocation';
import ProductTransactionCustomFields from './Common/ProductTransactionCustomFields';
import ProductTransactionSourceHandlingUnit from './Common/ProductTransactionSourceHandlingUnit';
import ProductTransactionDestinationLPN from './Common/ProductTransactionDestinationLPN';
import ProductTransactionDestinationSerial from './Common/ProductTransactionDestinationSerial';
import ProductTransactionDestinationLot from './Common/ProductTransactionDestinationLot';
import ProductTransactionIdentifier from './Common/ProductTransactionIdentifier';
import { Product } from '../../../../../../../types/product';
import ProductTransactionSourceCustomFields from './Common/ProductTransactionSourceCustomFields';

interface ProcessOrderTransactionDefaultBodyProps {
  transaction: ProductTransaction;
  setTransaction: React.Dispatch<React.SetStateAction<ProductTransaction>>;

  productMasterData?: ProductMasterData;
  container?: Container;
  disabled?: boolean;
  product?: Product;

  props: ProcessTransactionProps;
}

export interface ProcessTransactionProps {
  toContainerId?: string;
}

export default function ProcessOrderTransactionDefaultBody({
  transaction,
  setTransaction,
  productMasterData,
  container,
  disabled = false,
  product,
  props,
}: ProcessOrderTransactionDefaultBodyProps) {
  return (
    <Grid container spacing={1}>
      <ProductTransactionSourceStockLocation
        transaction={transaction}
        setTransaction={setTransaction}
        productMasterData={productMasterData}
        disabled={disabled || !!product}
        container={container}
      />
      <ProductTransactionSourceHandlingUnit
        transaction={transaction}
        setTransaction={setTransaction}
        productMasterData={productMasterData}
        disabled={disabled || !!product}
        container={container}
      />
      <ProductTransactionSourceBin
        transaction={transaction}
        setTransaction={setTransaction}
        productMasterData={productMasterData}
        disabled={disabled || !!product}
        container={container}
      />
      <ProductTransactionSourceContainer
        transaction={transaction}
        setTransaction={setTransaction}
        productMasterData={productMasterData}
        disabled={disabled || !!product}
        container={container}
      />
      <ProductTransactionIdentifier
        transaction={transaction}
        setTransaction={setTransaction}
        productMasterData={productMasterData}
        disabled={disabled || !!product}
        container={container}
      />
      <ProductTransactionSourceCustomFields
        transaction={transaction}
        setTransaction={setTransaction}
        productMasterData={productMasterData}
        container={container}
        disabled={disabled || !!product}
      />
      <ProductTransactionSourceKit
        transaction={transaction}
        setTransaction={setTransaction}
        productMasterData={productMasterData}
        disabled={disabled || !!product}
      />
      <ProductTransactionSourceLPN
        transaction={transaction}
        setTransaction={setTransaction}
        productMasterData={productMasterData}
        disabled={disabled || !!product}
        container={container}
      />
      <ProductTransactionSourceSerial
        transaction={transaction}
        setTransaction={setTransaction}
        productMasterData={productMasterData}
        disabled={disabled || !!product}
        container={container}
      />
      <ProductTransactionSourceLot
        transaction={transaction}
        setTransaction={setTransaction}
        productMasterData={productMasterData}
        disabled={disabled || !!product}
        container={container}
      />
      {transaction.type === ProductTransactionType.move ? (
        <Grid item xs={12} my={1}>
          <Divider />
        </Grid>
      ) : null}
      <ProductTransactionDestinationStockLocation
        transaction={transaction}
        setTransaction={setTransaction}
        productMasterData={productMasterData}
        disabled={disabled}
        container={container}
        props={props}
      />
      <ProductTransactionDestinationBin
        transaction={transaction}
        setTransaction={setTransaction}
        productMasterData={productMasterData}
        disabled={disabled}
        container={container}
        props={props}
      />
      <ProductTransactionDestinationContainer
        transaction={transaction}
        setTransaction={setTransaction}
        productMasterData={productMasterData}
        disabled={disabled}
        container={container}
        props={props}
      />
      <ProductTransactionProcessContainerChildren
        transaction={transaction}
        setTransaction={setTransaction}
        disabled={disabled}
        container={container}
      />
      <ProductTransactionDestinationCustomFields
        transaction={transaction}
        setTransaction={setTransaction}
        productMasterData={productMasterData}
        disabled={disabled}
        container={container}
      />
      <ProductTransactionDestinationKit
        transaction={transaction}
        setTransaction={setTransaction}
        productMasterData={productMasterData}
        disabled={disabled}
      />
      <ProductTransactionDestinationLPN
        transaction={transaction}
        setTransaction={setTransaction}
        productMasterData={productMasterData}
        disabled={disabled}
      />
      <ProductTransactionDestinationSerial
        transaction={transaction}
        setTransaction={setTransaction}
        productMasterData={productMasterData}
        disabled={disabled}
      />
      <ProductTransactionDestinationLot
        transaction={transaction}
        setTransaction={setTransaction}
        productMasterData={productMasterData}
        disabled={disabled}
        container={container}
      />
      {transaction.type === ProductTransactionType.move ? (
        <Grid item xs={12} my={1}>
          <Divider />
        </Grid>
      ) : null}
      <ProductTransactionQuantity
        transaction={transaction}
        setTransaction={setTransaction}
        productMasterData={productMasterData}
        disabled={disabled}
        container={container}
      />
      <ProductTransactionCustomFields
        transaction={transaction}
        setTransaction={setTransaction}
        productMasterData={productMasterData}
        disabled={disabled}
        container={container}
      />
    </Grid>
  );
}
